export const demoTestimonials = [
  {
    id: "t-101",
    fullName: "Sunita Mehra",
    city: "Gurgaon",
    mobile: "+91 98xxxxxx11",
    email: "sunita.m@example.com",
    rating: 5,
    message:
      "Aegis Care coordinated diagnostics, medicine reminders, and doctor consults for my father. The updates were timely and reassuring.",
    photo: "/ImageAndVideo/image/highl_family_mantor.jpg",
    verified: true,
    status: "approved",
    createdAt: "2026-04-12T10:00:00.000Z",
  },
  {
    id: "t-102",
    fullName: "Rajat Bansal",
    city: "Delhi",
    mobile: "+91 98xxxxxx24",
    email: "rajat.b@example.com",
    rating: 5,
    message:
      "My mother needed urgent follow-up after discharge. Their team arranged a home nurse and specialist consultation the same day.",
    photo: "/ImageAndVideo/image/Trusted_Homecare.jpg",
    verified: true,
    status: "approved",
    createdAt: "2026-03-28T09:30:00.000Z",
  },
  {
    id: "t-103",
    fullName: "Neha Khosla",
    city: "Noida",
    mobile: "+91 98xxxxxx39",
    email: "neha.k@example.com",
    rating: 4,
    message:
      "Tele-consult support and periodic health summaries helped our family stay informed even while we were abroad.",
    photo: "/ImageAndVideo/image/careimg2.jpeg",
    verified: true,
    status: "approved",
    createdAt: "2026-03-02T12:00:00.000Z",
  },
  {
    id: "t-104",
    fullName: "Amanpreet Singh",
    city: "Faridabad",
    mobile: "+91 98xxxxxx52",
    email: "amanpreet.s@example.com",
    rating: 5,
    message:
      "Excellent support and clear communication. We felt genuinely looked after.",
    photo: "/ImageAndVideo/image/careimg4.jpg",
    verified: false,
    status: "pending",
    createdAt: "2026-05-15T07:45:00.000Z",
  },
];

export const videoTestimonials = [
  {
    id: "v-1",
    name: "Priya Arora",
    city: "Delhi",
    duration: "02:14",
    thumbnail: "/ImageAndVideo/image/careimg1.jpg",
    title: "Post-surgery home care journey",
  },
  {
    id: "v-2",
    name: "Karan Sethi",
    city: "Noida",
    duration: "01:48",
    thumbnail: "/ImageAndVideo/image/careimg3.jpeg",
    title: "How tele-consults helped my parents",
  },
  {
    id: "v-3",
    name: "Aditi Malhotra",
    city: "Gurgaon",
    duration: "02:05",
    thumbnail: "/ImageAndVideo/image/careimg5.jpg",
    title: "Trusted support for senior wellness",
  },
];

export const blogPosts = [
  {
    id: "b-1",
    title: "8 Preventive Health Checks Every Senior Should Track",
    excerpt:
      "A simple monthly checklist to proactively monitor cardiac, renal, and metabolic risk in elderly family members.",
    category: "Preventive Care",
    author: "Dr. Aman Khera",
    date: "2026-05-10",
    readTime: "6 min read",
    image: "/ImageAndVideo/image/RemoteHealth.jpg",
    content:
      "Preventive care begins with predictable routines. Track blood pressure, fasting glucose, HbA1c, kidney function, ECG, bone health, nutrition status, and medicine adherence. Families can avoid crisis events by identifying early warning patterns and sharing trend reports with doctors.",
    featured: true,
  },
  {
    id: "b-2",
    title: "Caregiver Burnout: Early Signs and Practical Recovery",
    excerpt:
      "Caregiving is emotional work. Learn practical boundaries and support systems that reduce burnout without compromising care.",
    category: "Wellness Tips",
    author: "Clinical Care Team",
    date: "2026-04-22",
    readTime: "5 min read",
    image: "/ImageAndVideo/image/Trusted_Homecare.jpg",
    content:
      "Burnout appears as decision fatigue, sleep disruption, and emotional withdrawal. Build rotating responsibilities, schedule respite windows, and use short weekly care plans. Structured support is healthier than heroic last-minute responses.",
  },
  {
    id: "b-3",
    title: "Understanding Polypharmacy Risks in the Elderly",
    excerpt:
      "Multiple medicines can cause adverse interactions. Here is how families can maintain safer medication plans.",
    category: "Medical Awareness",
    author: "Pharma Advisory Desk",
    date: "2026-04-05",
    readTime: "7 min read",
    image: "/ImageAndVideo/image/TeleMedicineConnectivity.jpg",
    content:
      "Keep an updated medication chart with dosage, timing, and prescribing physician. Conduct medication reconciliation every quarter, especially after hospitalization. Ask for alternatives that reduce duplication and simplify schedules.",
  },
  {
    id: "b-4",
    title: "How NRIs Can Build a Reliable Care Plan from Abroad",
    excerpt:
      "A planning guide for families living overseas who need dependable care visibility for parents in India.",
    category: "Family Care",
    author: "Operations Team",
    date: "2026-03-19",
    readTime: "4 min read",
    image: "/ImageAndVideo/image/Reliable_Service.jpg",
    content:
      "Begin with baseline health records, emergency contacts, and escalation rules. Define monthly check-ins, assign point persons, and request concise digital summaries after every major appointment or test.",
  },
];

export const mediaItems = [
  {
    id: "m-1",
    type: "Press Release",
    title: "Aegis Care Expands Senior Homecare Programs in NCR",
    source: "HealthLine India",
    date: "2026-05-03",
    summary: "Expanded service coverage with coordinated telehealth and home visits.",
    image: "/ImageAndVideo/image/At-Home.jpg",
  },
  {
    id: "m-2",
    type: "Interview",
    title: "Founder Interview: Rebuilding Trust in Eldercare",
    source: "CareTalks Podcast",
    date: "2026-04-14",
    summary: "Dr. Aman Khera discusses operational transparency and family confidence.",
    image: "/ImageAndVideo/image/founder.jpg",
  },
  {
    id: "m-3",
    type: "Video",
    title: "Inside Aegis Care Coordination Workflow",
    source: "YouTube",
    date: "2026-04-08",
    summary: "A short walkthrough of triage, scheduling, and follow-up practices.",
    image: "/ImageAndVideo/image/careimg1.jpg",
  },
  {
    id: "m-4",
    type: "News",
    title: "Community Health Screening Drive Serves 300+ Seniors",
    source: "City Health Bulletin",
    date: "2026-03-27",
    summary: "Aegis Care and partner clinicians completed preventive screenings.",
    image: "/ImageAndVideo/image/Emergency_Services.jpg",
  },
  {
    id: "m-5",
    type: "Announcement",
    title: "New Family Dashboard for Monthly Care Updates",
    source: "Aegis Care",
    date: "2026-03-12",
    summary: "Families now receive concise monthly health summaries and alerts.",
    image: "/ImageAndVideo/image/RemoteHealth.jpg",
  },
  {
    id: "m-6",
    type: "Image Gallery",
    title: "Medical Camp Highlights",
    source: "Aegis Care Events",
    date: "2026-02-18",
    summary: "Snapshots from awareness camps and specialist sessions.",
    image: "/ImageAndVideo/image/careimg4.jpg",
  },
];

export const eventItems = [
  {
    id: "e-1",
    title: "Senior Cardiac Screening Camp",
    type: "Medical Camp",
    date: "2026-07-14T10:00:00+05:30",
    venue: "Punjabi Bagh Community Hall, New Delhi",
    description:
      "Free BP, ECG, and basic cardiac risk screening for senior citizens with one-on-one counselling.",
    image: "/ImageAndVideo/image/coreServices/health.jpg",
    cta: "Register Free",
    speakers: [
      {
        name: "Dr. Aman Khera",
        specialty: "Internal Medicine",
        image: "/ImageAndVideo/image/founder.jpg",
      },
      {
        name: "Dr. Rhea Sharma",
        specialty: "Cardiology",
        image: "/ImageAndVideo/image/careimg2.jpeg",
      },
    ],
  },
  {
    id: "e-2",
    title: "NRI Family Care Webinar",
    type: "Doctor Webinar",
    date: "2026-06-22T18:30:00+05:30",
    venue: "Online (Zoom)",
    description:
      "A practical webinar on planning preventive eldercare for parents in India while living overseas.",
    image: "/ImageAndVideo/image/TeleMedicineConnectivity.jpg",
    cta: "Reserve Seat",
    speakers: [
      {
        name: "Dr. Meenal Gupta",
        specialty: "Geriatric Care",
        image: "/ImageAndVideo/image/careimg3.jpeg",
      },
      {
        name: "Arjun Vohra",
        specialty: "Care Operations Lead",
        image: "/ImageAndVideo/image/careimg1.jpg",
      },
    ],
  },
  {
    id: "e-3",
    title: "Vaccination Awareness Drive",
    type: "Health Awareness Drive",
    date: "2026-08-03T09:00:00+05:30",
    venue: "Noida Sector 62 Club House",
    description:
      "Session focused on adult immunization schedules, myths, and safety protocols for elderly populations.",
    image: "/ImageAndVideo/image/coreServices/care.jpg",
    cta: "Join Event",
    speakers: [
      {
        name: "Dr. Kavita Ahuja",
        specialty: "Public Health",
        image: "/ImageAndVideo/image/careimg5.jpg",
      },
    ],
  },
];

export const trustStats = [
  { label: "Families Supported", value: 3200, suffix: "+" },
  { label: "Care Satisfaction", value: 98, suffix: "%" },
  { label: "Consultations Managed", value: 12500, suffix: "+" },
  { label: "Average Response Time", value: 18, suffix: " min" },
];

export const consultantDoctors = [
  { id: "d-1", name: "Dr. Aman Khera", department: "Internal Medicine" },
  { id: "d-2", name: "Dr. Rhea Sharma", department: "Cardiology" },
  { id: "d-3", name: "Dr. Meenal Gupta", department: "Geriatrics" },
  { id: "d-4", name: "Dr. Pankaj Suri", department: "Neurology" },
];

export const departments = [
  "Internal Medicine",
  "Cardiology",
  "Geriatrics",
  "Neurology",
  "Endocrinology",
  "Orthopedics",
];

export const consultantSlots = [
  "09:00 AM",
  "10:30 AM",
  "12:00 PM",
  "02:30 PM",
  "04:00 PM",
  "06:30 PM",
];

export const delhiNcrPincodes = [
  "110001",
  "110017",
  "110024",
  "110026",
  "110048",
  "110070",
  "121001",
  "121002",
  "122001",
  "122002",
  "201301",
  "201303",
  "201305",
  "201309",
  "201310",
  "201318",
];
